<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Thêm cán bộ
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="130px"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Email" prop="email">
              <el-input
                v-model="form.email"
                placeholder="Email"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="100"
                show-word-limit
                @change="emailChanged"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Họ tên" prop="userName">
              <el-input
                v-model="form.userName"
                placeholder="Họ tên"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Giới tính" prop="gender">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.gender"
                placeholder="Giới tính"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in genderOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Số điện thoại" prop="isdn">
              <el-input
                v-model="form.isdn"
                placeholder="Số điện thoại"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="20"
                show-word-limit
                @change="isdnChanged"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Hộ chiếu/CMTND" prop="identityNumber">
              <el-input
                v-model="form.identityNumber"
                placeholder="Hộ chiếu/CMTND"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Ngày sinh" prop="birthday">
              <el-date-picker
                v-model="form.birthday"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                type="date"
                placeholder="dd/MM/yyyy"
                format="dd/MM/yyyy"
                :prefix-icon="''"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Đại diện checkin" prop="isCheckIn">
              <el-checkbox v-model="form.isCheckIn"></el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Chức danh" prop="position">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.position"
                placeholder="Chức danh"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in positionOptions"
                  :key="item.id"
                  :label="item.positionName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Đơn vị" prop="department">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.department"
                placeholder="Đơn vị"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in departments"
                  :key="item.id"
                  :label="item.deptName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          {{ isEditMode ? "Lưu" : "Thêm" }}&nbsp;
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import CustomDialog from "../../common/custom-dialog";
  import hcCfgPositionService from "../../../services/maybay/hcCfgPositionService";
  import departmentService from "../../../services/departmentService";
  import constants from "../../../constants";
  import h from "../../../services/h";
  import hanhChinhUtils from "../../../services/hanhChinhUtils";
  import utils from "../../../services/utils";
  import userDeptRoleViewService from "../../../services/userDeptRoleViewService";

  export default {
    name: "hc-ks-add-user-dialog",
    mixins: [handleRequestErrorMixin],
    props: ["isOpen", "user"],
    components: {
      CustomDialog
    },
    data() {
      return {
        rules: {
          userName: null,
          gender: null,
          isdn: null,
          email: null,
          identityNumber: null,
          birthday: null,
          position: null,
          department: null,
          isCheckIn: false
        },
        form: {
          userName: null,
          gender: null,
          isdn: null,
          email: null,
          identityNumber: null,
          birthday: null,
          position: null,
          department: null,
          isCheckIn: null
        },
        genderOptions: [],
        positionOptions: [],
        departments: []
      };
    },

    watch: {},
    computed: {
      isEditMode() {
        return !!this.user;
      }
    },

    created() {
      this.initGenderOptions();
      this.loadPositionOptions();
      this.loadDepartments();
      this.initValidationRules();
      if (this.isEditMode) this.initFormForEdit();
    },

    methods: {
      emailChanged() {
        let email = this.form.email;
        if (email && email.length && utils.validateEmailFormat(email))
          userDeptRoleViewService.findByEmail(email).then(response => {
            let userDeptRoleViews = response.data;
            if (!userDeptRoleViews || !userDeptRoleViews.length) return;
            let userDeptRoleView = h.find(
              userDeptRoleViews,
              item =>
                (item.deptPath || "").startsWith(
                  `${this.$store.getters.globalRoles}`
                ) &&
                (constants.ROLE.CODE.LANH_DAO === item.roleCode ||
                  constants.ROLE.CODE.CHUYEN_VIEN === item.roleCode)
            );

            if (!userDeptRoleView) {
              userDeptRoleView = h.find(
                userDeptRoleViews,
                item =>
                  constants.ROLE.CODE.LANH_DAO === item.roleCode ||
                  constants.ROLE.CODE.CHUYEN_VIEN === item.roleCode
              );
            }

            if (!userDeptRoleView) userDeptRoleView = userDeptRoleViews[0];

            this.form.userName = userDeptRoleView.fullName;
            this.form.gender =
              userDeptRoleView.gender === constants.USERS.GENDER.MALE
                ? constants.HC_CASE_FLIGHT_USER.GENDER.MALE
                : userDeptRoleView.gender === constants.USERS.GENDER.FEMALE
                ? constants.HC_CASE_FLIGHT_USER.GENDER.FEMALE
                : null;
            this.form.isdn = userDeptRoleView.mobile;
            this.form.position = h.exists(
              this.positionOptions,
              item => item.id === userDeptRoleView.positionId
            )
              ? userDeptRoleView.positionId
              : null;
            this.form.department = h.exists(
              this.departments,
              item => item.id === userDeptRoleView.deptId
            )
              ? userDeptRoleView.deptId
              : null;
          });
      },

      initFormForEdit() {
        this.form.userName = this.user.userName;
        this.form.gender = this.user.gender;
        this.form.isdn = this.user.isdn;
        this.form.email = this.user.email;
        this.form.identityNumber = this.user.identityNumber;
        this.form.birthday = this.user.birthday
          ? new Date(this.user.birthday)
          : null;
        this.form.position = this.user.positionId;
        this.form.department = this.user.deptId;
        this.form.isCheckIn = this.user.isCheckIn;
      },

      isdnChanged() {
        this.form.isdn = utils.standardlizePhoneNumber(this.form.isdn);
      },

      initValidationRules() {
        let defaultRequiredConstrains = {
          required: true,
          message: "Trường dữ liệu bắt buộc",
          trigger: "blur"
        };
        let checkPhoneFormat = utils.buildPhoneValidationRule();

        let checkEmailFormat = (rule, value, callback) => {
          if (!value) return callback();
          if (!utils.validateEmailFormat(value.toLowerCase()))
            return callback(new Error("Định dạng email không đúng"));
          return callback();
        };

        this.rules.userName = [defaultRequiredConstrains];
        this.rules.gender = [defaultRequiredConstrains];
        this.rules.isdn = [{validator: checkPhoneFormat, trigger: "blur"}];
        this.rules.birthday = [defaultRequiredConstrains];
        this.rules.position = [defaultRequiredConstrains];
        this.rules.department = [defaultRequiredConstrains];
        this.rules.email = [{validator: checkEmailFormat, trigger: "blur"}];
      },

      initGenderOptions() {
        this.genderOptions = h.collect(
          [
            constants.HC_CASE_FLIGHT_USER.GENDER.MALE,
            constants.HC_CASE_FLIGHT_USER.GENDER.FEMALE
          ],
          gender => {
            return {
              id: gender,
              name: hanhChinhUtils.getHcGenderLabel(gender)
            };
          }
        );
      },

      loadPositionOptions() {
        return hcCfgPositionService
          .findAll()
          .then(response => (this.positionOptions = response.data));
      },

      loadDepartments() {
        return departmentService.findAllForHcMayBay().then(response => {
          this.departments = response.data || [];
          this.departments.sort((item1, item2) =>
            item1.deptName.localeCompare(item2.deptName)
          );
        });
      },

      validateForm() {
        return new Promise(resolve => {
          this.$refs.form.validate(valid => {
            if (!valid) {
              this.$message.error("Có lỗi nhập liệu. Vui lòng kiểm tra lại");
            } else {
              resolve();
            }
          });
        });
      },

      convertToSubmitForm() {
        return {
          userName: this.form.userName,
          gender: this.form.gender,
          isdn: this.form.isdn,
          email: this.form.email,
          identityNumber: this.form.identityNumber,
          birthday: this.form.birthday ? this.form.birthday.getTime() : null,
          positionId: this.form.position,
          deptId: this.form.department,
          isCheckIn: this.form.isCheckIn
        };
      },

      submit() {
        this.validateForm().then(() => {
          this.$emit("submit", {result: this.convertToSubmitForm()});
        });
      }
    }
  };
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/khachsan/hc-ks-add-user-dialog.vue